import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { Link } from "react-router-dom";

export default function RelatedProducts({ relatedProducts }) {
  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <Box mt={5}>
      <Typography variant="h6" fontWeight={800} mb={2.5}>
        محصولات مرتبط
      </Typography>
      <Grid container spacing={2}>
        {relatedProducts.map((item) => {
          // 1. Safely handle both string array and object array image formats
          const rawImage =
  typeof item.images?.[0] === "object"
    ? item.images[0]?.url
    : item.images?.[0];
    
    const BASE_URL = process.env.REACT_APP_API_URL;

    const imageUrl = rawImage
    ? rawImage.startsWith("http")
      ? rawImage
      : `${BASE_URL}${rawImage}`
    : null;
          return (
            <Grid key={item.id} size={{ xs: 6, sm: 4, md: 3, lg: 2.4 }}>
              <Paper
                component={Link}
                // 2. Fallback to item.id if item.slug is missing from API
                to={`/product/${item.slug || item.id}`}
                elevation={0}
                sx={{
                  p: 2,
                  height: "100%",
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "grey.200",
                  display: "flex",
                  flexDirection: "column",
                  textDecoration: "none",
                  color: "inherit",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    borderColor: "#8257ac",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    pt: "100%",
                    position: "relative",
                    borderRadius: 2,
                    overflow: "hidden",
                    mb: 1.5,
                    bgcolor: "grey.50",
                  }}
                >
                  {imageUrl && (
                    <Box
                      component="img"
                      src={imageUrl}
                      alt={item.title}
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        p: 1,
                      }}
                    />
                  )}
                </Box>

                <Typography variant="caption" color="primary.main" fontWeight={700}>
                  {item.brand}
                </Typography>

                <Typography
                  variant="body2"
                  fontWeight={700}
                  color="text.primary"
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    lineHeight: 1.5,
                    mt: 0.5,
                  }}
                >
                  {item.title}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}